import { render } from "./HOGCLogo.vue?vue&type=template&id=0c190416"
import script from "./HOGCLogo.vue?vue&type=script&lang=js"
export * from "./HOGCLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__